import { Box, Flex } from "rebass";
import InfoBox from "../../../Components/Common/InfoBox";
import TwoQPlus from "./ResultAiSection/TwoQPlus";
import SuicidalRisk from "./ResultAiSection/SuicidalRisk";
import SadnessCause from "./ResultAiSection/SadnessCause";

const ResultAiSection = ({ resultAi }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridGap: "12px",
        gridTemplateColumns: "1fr 2fr",
        width: "100%",
        alignSelf: "center",
        maxWidth: "1200px",
      }}
    >
      {/* Left Box (2Q Plus) */}
      <InfoBox title="2Q Plus">
        <TwoQPlus twoQPlusData={resultAi?.two_q_plus} />
      </InfoBox>

      {/* Right Box (Suicidal Risk) */}
      <InfoBox title="ความเสี่ยงฆ่าตัวตาย">
        <SuicidalRisk suicidalData={resultAi?.suicidal} />
      </InfoBox>

      {/* Bottom Box (Sadness cause) */}
      <Flex
        css={{
          gridColumnStart: 1,
          gridColumnEnd: 3,
        }}
      >
        <InfoBox title="เรื่องที่ทำให้เศร้า">
          <SadnessCause causes={resultAi?.chief_complaint?.sad} />
        </InfoBox>
      </Flex>
    </Box>
  );
};

export default ResultAiSection;
